import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import userActions from "../actions";
import { useSelector } from "react-redux";
import { UserRoleText, USER_PROP } from "../constants";

const useStyles = makeStyles((theme) => ({
  box: {
    margin: theme.spacing(1),
  },
  bold: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  AvatarSmall: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(2),
  },
  popoverItemDelete: {
    color: "#E16B66",
  },
}));

const TableActions = () => {
  const classes = useStyles();
  const { editUser } = useSelector((s) => s.user);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setDeleteConfirmationVisibility, openEditDialog } = userActions();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const deleteRow = () => {
    setAnchorEl(null);
    setDeleteConfirmationVisibility(true);
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const getActions = () => (
    <Box className={classes.box}>
      <Grid container direction="column">
        <Button
          onClick={() => {
            setAnchorEl(null);
            openEditDialog();
          }}
          className={classes.popoverItem}
        >
          Edit profile setting
        </Button>
        <Button
          color="secondary"
          onClick={() => deleteRow()}
          className={classes.popoverItemDelete}
        >
          Remove
        </Button>
      </Grid>
    </Box>
  );
  return (
    <Box>
      <Button
        aria-describedby={id}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        {matches ? <MoreHorizIcon /> : <MoreVertIcon />}
      </Button>

      {matches ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => {
            setAnchorEl(null);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {getActions()}
        </Popover>
      ) : (
        <Drawer
          anchor="bottom"
          open={open}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          {editUser[USER_PROP.FNAME] && (
            <Box p={3}>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Avatar className={classes.AvatarSmall}>
                    <Typography variant="h5" className={classes.AvatarText}>
                      {editUser[USER_PROP.FNAME][0]?.toUpperCase() +
                        editUser[USER_PROP.LNAME][0]?.toUpperCase()}
                    </Typography>
                  </Avatar>
                  <Typography variant="h5">
                    {`${editUser[USER_PROP.FNAME]} ${
                      editUser[USER_PROP.LNAME]
                    }`}
                  </Typography>
                </Grid>
              </Box>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Typography className={classes.bold} variant="subtitle1">
                    {"Role:"}
                  </Typography>
                  <Typography variant="subtitle1">
                    {UserRoleText[editUser[USER_PROP.ROLE]]}
                  </Typography>
                </Grid>
              </Box>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Typography className={classes.bold} variant="subtitle1">
                    {"Email:"}
                  </Typography>
                  <Typography variant="subtitle1">
                    {editUser[USER_PROP.EMAIL]}
                  </Typography>
                </Grid>
              </Box>
            </Box>
          )}
          <Divider />
          {getActions()}
        </Drawer>
      )}
    </Box>
  );
};

export default TableActions;
